import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useState } from "react";
import AddModal from "../modals/AddModal";

export interface AddButtonProps {}

export default function AddButton() {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Button startIcon={<AddIcon />} variant="contained" onClick={handleOpen}>
        Proposal
      </Button>
      <AddModal open={open} onClose={handleClose} />
    </>
  );
}
